module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2FEzQH/tc-custom/9780795350870.jpg?1705766068221",
      "alt": "This image is the cover for the book Jim Craig's Battle for Black Rock"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jim Craig's Battle for Black Rock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A courageous minister is out to save the souls of a frontier mining town in this nineteenth century Christian Western novel.")]), _c('br'), _c('br'), _vm._v("The mountain town of Black Rock is a place where hard-living miners find respite from their labors in the fleeting pleasure of the saloon. When Pastor Jim Craig arrives, he brings with him a radically different vision of salvation—one found in the everlasting love of the Lord. "), _c('br'), _c('br'), _vm._v("Jim believes the Gospel can change lives, and he’s determined to prove it. But those who profit off of whiskey and sin are equally determined to fight his message of reform. Written by a Canadian minister and first published in 1898, Jim Craig’s Battle for Black Rock is a timeless tale of Western adventure and the power of faith.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ralph Connor, Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0